// pipe (frontend wave FB): Refining sidebar entry (links to the Commodity Lots screen; the family's
// sub-nav reaches Assays + Bars). Cloned from records-button.tsx (verbatim shape) — only the route,
// the active-path prefix, the icon, the label key, and the testid differ. Not admin-gated: the
// server 403s unauthorized reads and the screens render the localized load-error state.
import { useI18n } from '@affine/i18n';
import { DiamondIcon } from '@blocksuite/icons/rc';
import { useServices } from '@toeverything/infra';

import { MenuLinkItem } from '../../modules/app-sidebar/views';
import { WorkbenchService } from '../../modules/workbench';
import { useNavPrefixActive } from './use-nav-prefix-active';

export const RefiningButton = () => {
  const t = useI18n();
  const { workbenchService } = useServices({ WorkbenchService });
  const workbench = workbenchService.workbench;
  // REACTIVE active state: any `/refining/*` route keeps the entry lit.
  const active = useNavPrefixActive(workbench, '/refining');

  return (
    <MenuLinkItem icon={<DiamondIcon />} active={active} to={'/refining/lots'}>
      <span data-testid="pipe-refining-nav">
        {t['com.affine.pipe.refining.nav']()}
      </span>
    </MenuLinkItem>
  );
};
